import { ReactNode, useEffect } from 'react';
import env from 'src/env';
import Topnav from 'src/Components/Navigation/Topnav';
import SideBarContainer from 'src/Components/Navigation/SideBarContainer';
import { useReactiveVar, useLazyQuery, useQuery } from '@apollo/client';
import { activePractitionerDetails, initLocale, isMobileNavOpen } from 'src/graphql';
import LUMINA_PROFILE_DETAILS from 'src/graphql/queries/practitonerQuery';
import USER_TOKEN from 'src/graphql/queries/authQuery';
import { Practitioner, ProfileMappingDetails } from '@luminalearning/types';

const getSelectedProfile = (practitionerProfileDetails: ProfileMappingDetails[], selectedPractitionerId: string) => (
    practitionerProfileDetails.find(
        (practitionerDetail) => practitionerDetail?.profile?.id === parseInt(selectedPractitionerId, 10)
    )
);

const MainLayout = ({ isHideSidebar, children }: { isHideSidebar?: boolean; children: ReactNode }) => {
    const practitionerId = localStorage.getItem('active_practitioner_id');
    const [getPractitioner, { loading }] = useLazyQuery(LUMINA_PROFILE_DETAILS);
    const practitionerDetails = useReactiveVar(activePractitionerDetails);
    const { data: token } = useQuery(USER_TOKEN);
    const isNavOpen = useReactiveVar(isMobileNavOpen);

    useEffect(() => {
        const ssoVersion = localStorage.getItem('ssoVersion');
        const ssoUrl = ssoVersion === '2' ? env.ssoV2Url : env.ssoV1Url;

        if (!practitionerId) {
            window.location.href = ssoUrl;
        }
        if (!practitionerDetails && practitionerId && Object.keys(token.token).length > 0) {
            initLocale();
            getPractitioner({
                onCompleted: (data) => {
                    let isPractitionerDataFound = false;
                    if (
                        data
                        && 'mappedLuminaProfileDetails' in data
                        && data.mappedLuminaProfileDetails
                        && 'practitioners' in data.mappedLuminaProfileDetails
                        && Array.isArray(data.mappedLuminaProfileDetails.practitioners)
                        && data.mappedLuminaProfileDetails.practitioners.length > 0
                    ) {
                        const activeProfile = getSelectedProfile(
                            data.mappedLuminaProfileDetails.practitioners, practitionerId
                        );
                        if (activeProfile) {
                            activePractitionerDetails(activeProfile.profile as unknown as Practitioner);
                            isPractitionerDataFound = true;
                        }
                    }

                    if (!isPractitionerDataFound) {
                        window.location.href = ssoUrl;
                    }
                },
                onError: (err) => {
                    console.error(err);
                    window.location.href = ssoUrl;
                },
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [practitionerDetails, practitionerId, token]);

    return (
        <div className='bg-primary w-auto h-auto'>
            {!loading && practitionerDetails
                && <>
                    <header>
                        <Topnav
                            isMobileNavOpen={isNavOpen}
                            setIsMobileNavOpen={isMobileNavOpen}
                            isHideSidebar={isHideSidebar || false}
                        />
                    </header>
                    <div className='flex bg-primary'>
                        <nav>
                            {!isHideSidebar && <SideBarContainer />}
                        </nav>
                        <main
                            className={
                                (!isMobileNavOpen || isHideSidebar)
                                    ? 'main'
                                    : 'md:m-0 p-2 pt-8 xl:pl-4 2xl:pl-20  3xl:pl-2 main'
                            }
                            id='mainContent'
                        >
                            {children}
                        </main>
                    </div>
                </> }
        </div>
    );
};

export default MainLayout;